<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <p [innerHTML]="confirmMessage"></p>
  <a mat-raised-button color="primary" [href]="'mailto:' + supportEmail">{{'detail-dialog.Contatta assistenza con il dettaglio' | translate}}</a>
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="dialogRef.close(false)">{{'detail-dialog.Ok' | translate}}</button>
</div>